var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tabs-panel"},[_c('wf-dev-ble-config-form',{attrs:{"deviceData":_vm.deviceData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }